"use client";

import { redirect } from "next/navigation";
import { FC } from "react";

const HomePage: FC = () => {
  redirect("/deals");
};

export default HomePage;
